import React, { useRef } from 'react';
import { Box, css, genesisStyled } from '@leagueplatform/genesis-commons';

// eslint-disable-next-line no-restricted-imports
import { Transition } from 'react-transition-group';
import type { TransitionStatus } from 'react-transition-group/Transition';
import { TransitionProps } from '#types/transition-props.type.ts';

const Element = genesisStyled(Box)(({ stylesProp }) =>
  css({
    ...stylesProp,
    opacity: 0,
  }),
);

const transitionStyles: Record<TransitionStatus, React.CSSProperties> = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
  unmounted: {},
};

export const FadeIn = ({
  isActive,
  stylesProp,
  duration,
  children = null,
}: TransitionProps) => {
  const ref = useRef<HTMLDivElement>(null);
  return (
    <Transition in={isActive} timeout={duration} nodeRef={ref}>
      {(state: TransitionStatus) => (
        <Element
          ref={ref}
          stylesProp={{
            ...stylesProp,
            transition: `opacity ${duration}ms ease-in-out`,
          }}
          style={{ ...transitionStyles[state] }}
        >
          {children && children}
        </Element>
      )}
    </Transition>
  );
};
